import Dowjones from './images/Dow_Jones_Logo.svg.png';
import Nasdaq from './images/nasdaq.png';
// import SP500 from './images/SP500.jpg';

const exchange = [
  {
    name: 'Dow Jones Industrial Average',
    symbol: 'dowjones',
    image: Dowjones,
    alt: 'DowJones logo',
  },
  {
    name: 'NASDAQ 100',
    symbol: 'nasdaq',
    image: Nasdaq,
    alt: 'NASDAQ logo',
  },
  // {
  //   name: 'S&P 500',
  //   symbol: 'sp500',
  //   image: SP500,
  //   alt: 'S&P 500 logo',
  // },
];

export default exchange;
